import { Marker } from 'react-map-gl'

import { FacilityMapMarker } from '@hivewatch/dark'

interface IProps {
  onPress?: () => void
  facility: {
    id: string
    latitude: number
    longitude: number
    incidentCount: number
    shortName: string
  }
}

const MARKER_SIZE = 50

/**
 * Positions the shared facility marker on the Global Map. The visual lives in
 * @hivewatch/dark so the Incident Drawer Map Panel renders the same thing
 * (ENG-33675); this file owns only the map placement.
 */
export const FacilityMarker = ({ facility, onPress }: IProps) => (
  <Marker
    latitude={facility.latitude}
    longitude={facility.longitude}
    offset={[-MARKER_SIZE / 2, -MARKER_SIZE / 2]}
  >
    <FacilityMapMarker
      incidentCount={facility.incidentCount}
      onClick={onPress}
      shortName={facility.shortName}
      size={MARKER_SIZE}
    />
  </Marker>
)
